import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import timerImage from '../assets/images/timer.jpg';
import FireworksBackground from './FireworksBackground';

const CountdownTimer: React.FC = () => {
  const weddingDate = new Date('2025-08-30T16:00:00');
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const now = new Date();
    const difference = weddingDate.getTime() - now.getTime();

    const time = {
      total: difference,
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };

    return time;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const showFireworks = timeLeft.total <= 0;

  return (
    <TimerContainer>
      {showFireworks && <FireworksBackground/>}
      {showFireworks ? <Celebration>
        <BigText>Czas świętować!</BigText>
        <SubText>Nie ma co odliczać :)</SubText>
      </Celebration>
      : <>
      <TimeBlock delay="0s">
          <TimeValue>{timeLeft.days}</TimeValue>
          <TimeLabel>Dni</TimeLabel>
        </TimeBlock>
        <TimeBlock delay="0.2s">
          <TimeValue>{timeLeft.hours}</TimeValue>
          <TimeLabel>Godziny</TimeLabel>
        </TimeBlock>
        <TimeBlock delay="0.4s">
          <TimeValue>{timeLeft.minutes}</TimeValue>
          <TimeLabel>Minuty</TimeLabel>
        </TimeBlock>
        <TimeBlock delay="0.6s">
          <TimeValue>{timeLeft.seconds}</TimeValue>
          <TimeLabel>Sekundy</TimeLabel>
        </TimeBlock>
      </>}
    </TimerContainer>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const TimerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start; /* Umieszczenie zegara w górnej części */
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
  height: 100dvh !important; /* Pełna wysokość widoku na mobilnym */
  background-image: url(${timerImage});
  background-size: cover;
  background-position: center top; /* Wyśrodkowanie tła na mobilnym */
  background-repeat: no-repeat;
  filter: grayscale(100%); /* Zastosowanie czarno-białego efektu */

  @media (min-width: 768px) {
    height: 80vh !important; /* Zmniejszenie wysokości o 1/3 na desktopie */
    background-position: center top 70%; /* Przesunięcie tła na desktopie */
  }
`;

const TimeBlock = styled.div<{ delay: string }>`
  text-align: center;
  animation: ${fadeIn} 0.8s ease-in-out;
  animation-delay: ${(props) => props.delay};
  animation-fill-mode: both;
  margin-top: 1rem; /* Przesunięcie zegara o 1rem w dół */

  @media (min-width: 768px) {
    margin-top: 2rem; /* Usunięcie przesunięcia na desktopie */
  }
`;

const TimeValue = styled.div`
  font-size: 3rem;
  font-family: 'Cutive Mono', monospace;
  color: #fff; /* Biały kolor tekstu dla lepszej widoczności */
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); /* Subtelny cień dla kontrastu */
`;

const TimeLabel = styled.div`
  font-size: 1rem;
  color: #fff; /* Taki sam kolor jak TimeValue */
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); /* Ten sam cień co TimeValue */
`;

const Celebration = styled.div`
  position: relative;
  z-index: 2; /* nad fajerwerkami */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const BigText = styled.h1`
  font-size: 3rem;
  color: #fefcf9;
  text-shadow: 0 2px 2px rgba(87, 82, 82, 0.7);
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    font-size: 5rem;
  }
`;

const SubText = styled.p`
  font-size: 1.5rem;
  color: #fefcf9;
  text-shadow: 0 3px 5px rgba(87, 82, 82, 0.6);

  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;

export default CountdownTimer;